import { useEffect, useMemo, useState } from 'react'
import { Button, Dialog, DialogTitle, Typography } from '@mui/material'
import axios from 'axios'
import { format } from 'date-fns'
import ReactGA from 'react-ga4'
import { useNavigate, useParams } from 'react-router-dom'
import { AppConstants, Flow_Type, LeadStage } from 'AppConstants/AppConstants'
import Footer from 'components/Footer'
import Header from 'components/Header'
import { SetPurchasedPlanBooking, SetTimeLeftToExpireBooking } from 'redux/booking'
import { useAppDispatch, useAppSelector } from 'redux/store'
import styles from './ConfirmAppointment.module.scss'

const ConfirmAppointmentBooking = () => {
  const styless: any = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    //   position: 'absolute' as 'absolute',
    //   top: '44%',
    //   left: '47.5%',
    //   transform: 'translate(-50%, -50%)',
    width: 300,
    height: 170,
    overflow: 'hidden',
    backgroundColor: '#050624',
    color: 'white',
    borderRadius: '8px',
    p: 4,
  }
  const { id } = useParams()
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const appointmentTime = useAppSelector((state) => state.booking.selectedSlotBooking)
  const paymentDone = useAppSelector((state) => state.booking.paymentDoneBooking)
  const plans = useAppSelector((state) => state.booking.availablePlansBooking)
  const visitCount = useAppSelector((state) => state.booking.visitCountBooking)
  const purchasedPlan = useAppSelector((state) => state.booking.purchasedPlanBooking)
  const selectedPlan = useAppSelector((state) => state.booking.selectedPlanBooking)
  const studios = useAppSelector((state) => state.booking.studiosBooking)
  const selectedStudio = useAppSelector((state) => state.booking.selectedStudioBooking)
  const isMoreThanOneStudio = useAppSelector((state) => state.booking.isMoreThanOneStudioBooking)
  const channelBooking = useAppSelector((state) => state.booking.channel)
  const referralCode = useAppSelector((state) => state.booking.referralCodeBooking)
  const leadType = useAppSelector((state) => state.booking.leadType)
  const timeLeft: any = useAppSelector((state) => state.booking.timeLeftToExpireBooking)
  const [error, setError] = useState(false)
  const [slotNotFound, setSlotNotFound] = useState(false)

  const plan = useMemo(() => {
    if (plans) {
      const filterOnDemand = plans?.filter((p) => p.type === 'on-demand')
      return filterOnDemand
    } else {
      return null
    }
  }, [plans])

  const subscriptionType = useMemo(() => {
    if (plans) {
      const filterSubscription = plans?.filter((p) => p.type === 'subscription')
      return filterSubscription
    } else {
      return null
    }
  }, [plans])

  console.log(plan, 'plan list')

  const schedulePhysicalVisit = async () => {
    if (appointmentTime?.scheduleObject) {
      const response: any = await axios
        .post(AppConstants.API_URL + '/visit/chiropractor/appointment', appointmentTime.scheduleObject, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('userToken')}`,
            'x-platform-id': process.env.REACT_APP_PLATFORM_ID || '',
          },
        })
        .then((res) => {
          return res
        })
        .catch((err) => {
          return err.response
        })

      if (response?.data?.code === 'success') {
        // ReactGA.event('conversion', {
        //   send_to: process.env.REACT_APP_GA_CONVERSION_ID || 'AW-11337579902/40e2CN_xnqkZEP76lp4q',
        //   value: plan && plan[0] && plan[0]?.amount > 0 ? plan[0].amount / 100 : 0,
        //   currency: 'USD',
        // })
        navigate(`/booking/${id}/welcome`)
      } else {
        if (response?.data?.code === 'slot_booked_already') {
          setError(true)
        } else if (response?.data?.code === 'slot_not_found') {
          setSlotNotFound(true)
        }
        return false
      }
    } else {
      return false
    }
  }

  async function purchasePlan(selectedPlanId: string | undefined) {
    try {
      const response: any = await axios
        .post(
          `${AppConstants.API_URL}/payment-plan/purchase`,
          { planId: selectedPlanId, quantity: 1 },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('userToken')}`,
              'x-platform-id': process.env.REACT_APP_PLATFORM_ID || '',
            },
          },
        )
        .then((res) => {
          if (res && res?.data && res?.data?.data) {
            dispatch(SetPurchasedPlanBooking(res?.data?.data))
            navigate(`/booking/${id}/payment`)
          }
        })
        .catch((err) => {
          if (err) {
            alert('Something went wrong. Please try again.')
          }
        })
    } catch (error) {
      console.error(error)
    }
  }

  // const purchaseFreeCredit = async () => {
  //   try {
  //     const response: any = await axios
  //       .post(`${AppConstants.API_URL}/visit/chiropractor/free-appointment`, null, {
  //         headers: {
  //           Authorization: `Bearer ${localStorage.getItem('userToken')}`,
  //           'x-platform-id': process.env.REACT_APP_PLATFORM_ID || '',
  //         },
  //       })
  //       .then((res) => {
  //         console.log(res?.data.code, 'res?.data.code')
  //         if (res && res?.data.code === 'success') {
  //           schedulePhysicalVisit()
  //         }
  //       })
  //       .catch((err) => {
  //         if (err) {
  //           alert('Something went wrong. Please try again.')
  //         }
  //       })
  //   } catch (error) {
  //     console.error(error)
  //   }
  // }

  const formatTime = (seconds: number) => {
    const minutes = Math.floor(seconds / 60)
    const remainingSeconds = seconds % 60
    return `${minutes}:${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}`
  }

  const postLeadStage = async () => {
    await axios
      .post(
        AppConstants.API_URL + '/lead/stage/update',
        { stage: LeadStage.confirmation, channel: channelBooking },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('userToken')}`,
            'x-platform-id': process.env.REACT_APP_PLATFORM_ID || '',
          },
        },
      )
      .then((res) => {
        return res
      })
      .catch((err) => {
        return err?.response
      })
  }

  useEffect(() => {
    postLeadStage()
  }, [])

  useEffect(() => {
    ReactGA.event('page_view', {
      page_title: 'booking|Payment',
      page_location: `/booking/${id}/payment`,
    })
  }, [])

  useEffect(() => {
    dispatch(SetTimeLeftToExpireBooking(timeLeft ?? 299))
  }, [])

  useEffect(() => {
    if (timeLeft > 0) {
      const timerId = setInterval(() => {
        dispatch(SetTimeLeftToExpireBooking(timeLeft && timeLeft - 1))
      }, 1000)

      return () => clearInterval(timerId)
    }
  }, [timeLeft])

  return (
    <>
      <div className={styles.container}>
        <Header
          headerText=""
          showBackButton={true}
          onBack={() => {
            if (referralCode === null) {
              navigate(`/booking/${id}/choose-plan`)
            } else {
              navigate(`/booking/${id}/physical-visit`)
            }
          }}
        ></Header>
        <div className={styles.locationContainer}>
          <div className={styles.confirmHeader}>Confirm your appointment.</div>
          {studios && (
            <div className={styles.locationDetails}>
              <div className={styles.locationTextContainer}>
                <div className={styles.locationWrapper}>
                  <div className={styles.appointmentTime}>
                    {appointmentTime
                      ? format(new Date(appointmentTime?.scheduleObject.appointmentTime), 'EEEE, MMM dd')
                      : ''}
                    <div>
                      {appointmentTime
                        ? format(new Date(appointmentTime?.scheduleObject.appointmentTime), 'h:mm a')
                        : ''}
                    </div>
                    <div style={{ fontSize: '16px', fontWeight: 400 }}>Exam + Adjustment</div>
                  </div>
                  <div>
                    <div className={styles.locationText} style={{ fontWeight: 700 }}>
                      {isMoreThanOneStudio ? selectedStudio?.name : studios[0]?.name}
                    </div>
                    <div className={styles.locationText}>
                      {isMoreThanOneStudio ? selectedStudio?.address : studios[0]?.address}
                    </div>
                    {isMoreThanOneStudio ? (
                      <div className={styles.cityAndState}>
                        <div style={{ marginRight: '4px' }}>{selectedStudio?.city.name + ','}</div>
                        <div style={{ marginRight: '4px', textTransform: 'uppercase' }}>{selectedStudio?.state}</div>
                        <div>{selectedStudio?.zipCode}</div>
                      </div>
                    ) : (
                      <div className={styles.cityAndState}>
                        <div style={{ marginRight: '4px' }}>{studios[0]?.city.name + ','}</div>
                        <div style={{ marginRight: '4px', textTransform: 'uppercase' }}>{studios[0]?.state}</div>
                        <div>{studios[0]?.zipCode}</div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <img
                style={{ width: '145px', height: '150px', objectFit: 'cover' }}
                className={styles.mapImageItem}
                src={isMoreThanOneStudio ? selectedStudio?.mapImage || '' : studios[0]?.mapImage || ''}
                alt="map"
                onClick={() => {
                  if (studios && selectedStudio && selectedStudio?.mapLocation && isMoreThanOneStudio) {
                    window.open(selectedStudio.mapLocation, '_blank')
                  } else if (studios && studios.length === 1 && studios[0]?.mapLocation) {
                    window.open(studios[0].mapLocation, '_blank')
                  }
                  //   window.location.href =
                  //     'https://www.google.com/maps/place/302+Mott+St,+New+York,+NY+10012,+USA/@40.7248592,-73.9940347'
                }}
              />
            </div>
          )}

          {error && (
            <Dialog
              onClose={() => {
                // setError(false)
              }}
              open={error}
              PaperProps={{
                style: {
                  background: 'var(--color-background)',
                  borderRadius: '12px',
                  padding: '10px 12px',
                  minWidth: 300,
                  maxWidth: 300,
                  minHeight: 'auto',
                  // height: 170,
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'flex-start',
                  flex: 1, // align everything to the left
                  textAlign: 'left', // global text alignment
                },
              }}
            >
              <DialogTitle
                style={{
                  fontSize: '16px',
                  fontWeight: 700,
                  color: 'var(--color-text-primary)',
                  textAlign: 'left',
                  marginBottom: '12px',
                  padding: 0,
                  width: '100%',
                }}
              >
                Time Limit Reached
              </DialogTitle>
              <Typography
                style={{
                  color: 'var(--color-text-primary)',
                  fontSize: '14px',
                  textAlign: 'left',
                  marginBottom: '24px',
                  lineHeight: 1.5,
                  width: '100%',
                }}
              >
                Your booking session expired. Please select another available slot to continue.
              </Typography>
              <Button
                color="primary"
                style={{
                  marginBottom: '0.3rem',
                  height: '42px',
                  padding: '0px 8px 0px 8px',
                  fontSize: '14px',
                  alignSelf: 'center',
                }}
                onClick={() => {
                  setError(false)
                  navigate(`/booking/${id}/physical-visit`)
                }}
              >
                Reschedule
              </Button>
            </Dialog>
          )}
          {slotNotFound && (
            <Dialog
              onClose={() => {
                // setError(false)
              }}
              open={slotNotFound}
              PaperProps={{ style: styless }}
              className={styles.modalPopUp}
            >
              <DialogTitle
                style={{
                  fontSize: '16px',
                  fontWeight: 700,
                  color: 'var(--color-text-primary)',
                  textAlign: 'left',
                  marginBottom: '12px',
                  padding: 0,
                  width: '100%',
                }}
              >
                Slot Unavailable
              </DialogTitle>
              <Typography
                style={{
                  color: 'var(--color-text-primary)',
                  fontSize: '14px',
                  textAlign: 'left',
                  marginBottom: '24px',
                  lineHeight: 1.5,
                  width: '100%',
                }}
              >
                Your payment has been processed successfully. Unfortunately, the slot you selected is no longer
                available. Please choose another available slot.
              </Typography>
              <Button
                color="primary"
                style={{
                  marginBottom: '0.3rem',
                  height: '42px',
                  padding: '0px 8px 0px 8px',
                  fontSize: '14px',
                  alignSelf: 'center',
                }}
                onClick={() => {
                  setSlotNotFound(false)
                  navigate(`/booking/${id}/physical-visit`)
                }}
              >
                Reschedule
              </Button>
            </Dialog>
          )}
        </div>
        {!referralCode && (
          <div className={styles.cancellationPolicy}>
            <div className={styles.policyHeader}>Appointment Change Policy</div>
            <div className={styles.cancellation}>
              <strong>Cancellations:</strong> Cancellations made at least 12 hours before the appointment time will not
              incur a fee. Cancellations made between 12 hours and 1 hour before the appointment will incur a $10 fee,
              and those made less than 1 hour before, or in the case of a no-show, will incur a $20 fee. <br></br>
              <br></br>
              <strong>Same-Day Reschedules:</strong> Appointments can be rescheduled for the same day at no charge if
              done at least 1 hour in advance. Same-day reschedules made within 1 hour of the appointment time will
              incur a $20 short-notice fee.<br></br>
              <br></br>
              These policies ensure fair access for all Members and allow our doctors to provide care to other patients
              in need.
            </div>
          </div>
        )}
        {plan && plan[0]?.amount !== 0 && referralCode ? (
          <div className={styles.offerDetails}>
            <span className={styles.offerDetailsHeader}>New Patient Special Policy</span>
            <div className={styles.offerText}>
              A non-refundable payment is required to reserve your appointment. Please complete your payment to confirm
              your booking.
            </div>
          </div>
        ) : null}
        {plan && plan[0]?.amount === 0 && referralCode && (
          <div className={styles.cardRequiredPolicy}>
            <div className={styles.policyHeader}>Card Required to Confirm Appointment</div>
            <div className={styles.cardRequired}>
              A credit card is required to secure your free booking. Your card won't be charged today. It's only used if
              you non-show or cancel. No-shows or cancellations will result in a $40 non-refundable charge. This policy
              ensures fair access to slots for all patients while respecting our doctor's time.
            </div>
          </div>
        )}
        {referralCode ? (
          <div className={styles.offerExpires}>
            Offer Expires In: <span className={styles.timer}>{formatTime(timeLeft || 0)}</span>
          </div>
        ) : null}
        {/* {leadType !== Flow_Type.OFFERS ? (
          <div className={styles.cancellationPolicy}>
            <div className={styles.policyHeader}>Cancellation Policy</div>
            <div className={styles.cancellation}>
              Appointments canceled or rescheduled at least 12 hours in advance of the appointment time will not incur a
              penalty. Cancellations made between 12 hours and 1 hour in advance of the appointment time will result in
              a $10 penalty. If canceled less than 1 hour in advance of the appointment time or in the case of a
              no-show, a $20 penalty will apply. This policy ensures that our doctors can offer the slot to other
              patients in need of care.
            </div>
          </div>
        ) : null} */}
        <Footer
          buttonText={
            plan && plan[0]?.amount === 0
              ? 'Add Card to Confirm'
              : (!paymentDone && plan && plan[0]?.amount > 0) || (selectedPlan && selectedPlan?.amount > 0)
              ? referralCode === null
                ? `Confirm and Pay $${selectedPlan && selectedPlan?.amount / 100}`
                : `Confirm and Pay $${plan && plan[0]?.amount / 100}`
              : 'Confirm'
          }
          isLoading={false}
          trackerIndex={referralCode === null ? (isMoreThanOneStudio ? 4 : 3) : isMoreThanOneStudio ? 3 : 2}
          shouldShowFour={!isMoreThanOneStudio && referralCode ? false : true}
          shouldShowFive={referralCode === null && isMoreThanOneStudio ? true : false}
          isDisabled={false}
          buttonType={'button'}
          onButtonClick={() => {
            if (plan && plan[0]?.amount === 0 && appointmentTime?.scheduleObject) {
              navigate(`/booking/${id}/payment-setup`)
            } else if (appointmentTime?.scheduleObject && plan && plan[0]?.amount > 0) {
              if (!paymentDone) {
                if (!referralCode) {
                  purchasePlan(selectedPlan?.id)
                } else {
                  purchasePlan(plan[0]?.id)
                }
              } else {
                schedulePhysicalVisit()
              }
            } else if (appointmentTime?.scheduleObject && subscriptionType && subscriptionType[0]?.amount > 0) {
              if (!paymentDone) {
                purchasePlan(selectedPlan?.id)
              } else {
                schedulePhysicalVisit()
              }
            }
          }}
        ></Footer>
      </div>
    </>
  )
}

export default ConfirmAppointmentBooking
